import { render, staticRenderFns } from "./PlayDropdownItem.vue?vue&type=template&id=28ae7adc&scoped=true"
import script from "./PlayDropdownItem.vue?vue&type=script&lang=js"
export * from "./PlayDropdownItem.vue?vue&type=script&lang=js"
import style0 from "./PlayDropdownItem.vue?vue&type=style&index=0&id=28ae7adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ae7adc",
  null
  
)

export default component.exports